import "./RandUser.css"

export default function User({color, faceIndex}) {
    return (
        <div className="randUser">
            <div className={`face ${color}`}>{faceIndex}</div>
        </div>
    )
}